import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaBookOpen, FaCalendarAlt, FaChalkboardTeacher, FaChartBar, FaComments, FaEdit, FaLaptop, FaPaperPlane, FaPhotoVideo, FaShoppingCart, FaSignOutAlt, FaUserCircle, FaWallet } from 'react-icons/fa';
import { setIsLoggedIn, setUserInfo, setUserInfo2 } from '../reduxToolkit/redux';
import { endAppSession } from '../mymod/appSession';
import { isParentAccount, isStudentAccount, isTeacherAccount } from '../mymod/accountRole';
import fnc from '../mymod/commFunction';
import BillingBalance from '../billing/BillingBalance';
import './MenuPage.scss';

function MenuPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isParent = isParentAccount();
  const loginState = useSelector((state) => state.reduxStore) || {};
  const primaryUser = loginState.userInfo || {};
  const socialUser = loginState.userInfo2 || {};
  const currentUser = primaryUser.id ? primaryUser : socialUser;
  const isTeacher = isTeacherAccount(currentUser);
  const canOrderBooks = isTeacher || isStudentAccount(currentUser);
  const hasAppSession = Boolean(fnc.getCookie('appSessionToken'));
  const accountId = String((primaryUser.id || socialUser.id2 || socialUser.id)
    || (hasAppSession ? fnc.getCookie('id') : '') || '').trim();
  const accountName = String(currentUser.name || currentUser.nickname
    || (hasAppSession ? fnc.getCookie('userName') : '') || (isParent ? '학부모' : '로그인 계정')).trim();
  const guardianPhone = String(currentUser.phone || currentUser.hp
    || accountId.match(/(?:^|_)P_(\d{10,11})$/i)?.[1]
    || (hasAppSession ? fnc.getCookie('parentPhone') || fnc.getCookie('hp') : '')
    || '').replace(/\D/g, '');
  const maskedPhone = /^\d{10,11}$/.test(guardianPhone)
    ? `${guardianPhone.slice(0, 3)}-****-${guardianPhone.slice(-4)}` : '';
  const accountDetail = isParent
    ? (maskedPhone ? `휴대폰 ${maskedPhone}` : '학부모 계정')
    : (accountId || '계정 정보를 확인해 주세요.');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const logoutPending = useRef(false);

  const handleLogout = async () => {
    if (logoutPending.current) return;
    logoutPending.current = true;
    setIsLoggingOut(true);
    try {
      await endAppSession();
      dispatch(setUserInfo({}));
      dispatch(setUserInfo2({}));
      dispatch(setIsLoggedIn(false));
      navigate('/login');
    } finally {
      logoutPending.current = false;
      setIsLoggingOut(false);
    }
  };

  return (
    <main className="menu-page">
      <header className="menu-account-bar" aria-label="현재 로그인 계정">
        <div className="menu-account-bar__inner">
          <div className="menu-account">
            <FaUserCircle aria-hidden="true" />
            <div className="menu-account__details">
              <strong className="menu-account__name" title={accountName}>{accountName}</strong>
              <span className="menu-account__id" title={accountDetail}>{accountDetail}</span>
            </div>
          </div>
          <button
            type="button"
            className="menu-logout-btn"
            onClick={handleLogout}
            disabled={isLoggingOut}
            aria-busy={isLoggingOut}
            title="로그아웃"
          >
            <FaSignOutAlt aria-hidden="true" />
            <span>{isLoggingOut ? '로그아웃 중' : '로그아웃'}</span>
          </button>
        </div>
      </header>
      <section className="menu-panel" aria-label="서비스 선택">
        <h1>AI K-EDU</h1>
        <p>{isParent ? '자녀의 학습 현황을 확인하고 선생님과 소통하세요.' : '원하는 서비스를 선택하세요.'}</p>
        {!isParent && <BillingBalance />}

        <div className="menu-actions">
          {isParent ? (
            <>
            <button type="button" className="menu-action-btn" onClick={() => navigate('/lms/report')}>
              <FaChartBar className="menu-action-icon" aria-hidden="true" />
              <span>자녀 학습 리포트</span>
            </button>
            <button type="button" className="menu-action-btn" onClick={() => navigate('/scheduler/children')}>
              <FaCalendarAlt className="menu-action-icon" aria-hidden="true" />
              <span>자녀 학습 스케줄</span>
            </button>
            <button type="button" className="menu-action-btn" onClick={() => navigate('/talk')}>
              <FaComments className="menu-action-icon" aria-hidden="true" />
              <span>TALK</span>
            </button>
            </>
          ) : <>
          <button type="button" className="menu-action-btn" onClick={() => navigate('/wallet')}>
            <FaWallet className="menu-action-icon" aria-hidden="true" />
            <span>내 AI 지갑 · 충전</span>
          </button>
          <button
            type="button"
            className="menu-action-btn"
            onClick={() => navigate('/aiStudy')}
          >
            <FaBookOpen className="menu-action-icon" aria-hidden="true" />
            <span>AI STUDY</span>
          </button>

          <button
            type="button"
            className="menu-action-btn"
            onClick={() => navigate('/aiEssay')}
          >
            <FaEdit className="menu-action-icon" aria-hidden="true" />
            <span>AI 서술형 및 논술 첨삭</span>
          </button>

          <button
            type="button"
            className="menu-action-btn"
            onClick={() => navigate('/talk')}
          >
            <FaComments className="menu-action-icon" aria-hidden="true" />
            <span>AI TALK</span>
          </button>

          <button
            type="button"
            className="menu-action-btn"
            onClick={() => navigate('/lms')}
          >
            <FaLaptop className="menu-action-icon" aria-hidden="true" />
            <span>디지털 LMS</span>
          </button>

          {isTeacher && (
            <button
              type="button"
              className="menu-action-btn menu-teacher-lms-link"
              onClick={() => navigate('/teacher-lms')}
              aria-label="선생님 LMS"
              title="선생님 전용 PC 학습 관리 화면을 엽니다."
            >
              <FaChalkboardTeacher className="menu-action-icon" aria-hidden="true" />
              <span>선생님 LMS</span>
              <span className="menu-action-note" aria-hidden="true">PC</span>
            </button>
          )}

          {canOrderBooks && (
            <button
              type="button"
              className="menu-action-btn"
              onClick={() => navigate('/storeBook')}
            >
              <FaShoppingCart className="menu-action-icon" aria-hidden="true" />
              <span>교재·문제 구매</span>
            </button>
          )}

          <button
            type="button"
            className="menu-action-btn"
            onClick={() => navigate('/scheduler')}
          >
            <FaCalendarAlt className="menu-action-icon" aria-hidden="true" />
            <span>AI 스케줄러</span>
          </button>

          <button
            type="button"
            className="menu-action-btn"
            onClick={() => navigate('/aiMediaOn')}
          >
            <FaPhotoVideo className="menu-action-icon" aria-hidden="true" />
            <span>AI 미디어 온</span>
          </button>

          <button
            type="button"
            className="menu-action-btn menu-action-hidden"
            onClick={() => navigate('/talk-send')}
          >
            <FaPaperPlane className="menu-action-icon" aria-hidden="true" />
            <span>TALK 발송</span>
          </button>
          </>}
        </div>
      </section>
    </main>
  );
}

export default MenuPage;



